<ng-template #errorView>
    <div class="message-panel">
        <div class="theme-info-i">{{ sitecore.globalMessages.TournamentNotFound }}</div>
    </div>
</ng-template>

<div class="events events-tournament" *ngIf="!error; else errorView" (swiperight)="goBack()">
    <div *ngIf="live?.visible">
        <ms-heading class="section-heading" [title]="live?.title"></ms-heading>
        <ms-grid tracking="Tournament/Live" *ngIf="live?.grid | async as gridModel" [model]="gridModel"></ms-grid>
    </div>

    <div *ngIf="leagueList?.visible">
        <ms-heading class="section-heading" [title]="leagueList?.title"></ms-heading>

        <div class="league-section list list-card">
            <ms-item *ngFor="let league of leagueList?.leagues" [class.hidden]="!league.count" [count]="league.count" [href]="league.url">
                <ms-favourite-league-toggle item-icon [name]="league.name" [id]="league.id.preMatch" [sport]="sport.id"></ms-favourite-league-toggle>
                <div
                    item-title
                    *ngIf="getView(league.participants) === viewType.Club || getView(league.participants) === viewType.MultiClub"
                    [ngClass]="{
                        'club': getView(league.participants) === viewType.Club,
                        'multi-club': getView(league.participants) === viewType.MultiClub,
                    }">
                    <div class="league-section-name">{{ league.name }}</div>
                    <div class="league-section-participant" *ngIf="league.participants.length">
                        {{ getParticipants(league.participants) }}
                    </div>
                </div>

                <div item-title class="country" *ngIf="getView(league.participants) === viewType.Country">
                    <div class="league-section-icon"><i class="country-icon c{{ league.participants[0].id }}"></i></div>
                    <div class="league-section-name">{{ league.name }}</div>
                    <div class="league-section-participant" *ngIf="league.participants.length">
                        {{ getParticipants(league.participants) }}
                    </div>
                </div>

                <div item-title class="multi-country" *ngIf="getView(league.participants) === viewType.MultiCountry">
                    <div class="league-section-name">{{ league.name }}</div>
                    <div class="league-section-participant" *ngIf="league.participants.length">
                        <div class="participant" *ngFor="let participant of league.participants">
                            <div class="participant-icon"><i class="country-icon c{{ participant.id }}"></i></div>
                            <div class="participant-name">{{ participant.short }}</div>
                        </div>
                    </div>
                </div>
            </ms-item>
        </div>
    </div>

    <div *ngIf="preMatch?.visible">
        <ms-heading class="section-heading" [title]="preMatch?.title"></ms-heading>
        <ms-grid tracking="Tournament/PreMatch" *ngIf="preMatch?.grid | async as gridModel" [model]="gridModel"></ms-grid>
    </div>
</div>
